let prefix = "";

if (window.location.hostname.startsWith("localhost")) {
    prefix = window.location.fileBaseUrl ?? "";
}

export function getMediaFilePath(input, fileType) {
    if (!input) return input;
    if (typeof input === "string") {
        const url = `${prefix}${input.replace(/^~/, '').split('?')[0]}`
        return {
            url,
            label: url.substring(0, url.lastIndexOf('/') + 1)
        };
    }
    else if (input.courseApplicationEntryCriteriaId && input.fileId) {
        return {
            url: `${prefix}/api/file/entrycriteria/${input.courseApplicationEntryCriteriaId}`,
            label: "Open File",
            remove: input?.file?.remove
        };
    }
    else if (input.courseApplicationEducationId && input.fileId) {
        return {
            url: `${prefix}/api/file/educationhistory/${input.courseApplicationEducationId}`,
            label: "Open File",
            remove: input?.file?.remove
        };
    }
    else if (input.courseStudentAssessmentId) {
        const t = fileType || input.type;
        if (t === "PAPER" && !input.assessmentPaper || 
            t === "MARKED_PAPER" && !input.markedPaper || 
            t === "RESUBMITTED_PAPER" && !input.resubmittedAssessmentPaper || 
            t === "RESUBMITTED_MARKED_PAPER" && !input.resubmittedMarkedPaper
        ) {
            return null;
        }

        let f;
        switch (t) {
            case "PAPER":
                f = input.assessmentPaper;
                break;
            case "MARKED_PAPER":
                f = input.markedPaper;
                break;
            case "RESUBMITTED_PAPER":
                f = input.resubmittedAssessmentPaper;
                break;
            case "RESUBMITTED_MARKED_PAPER":
                f = input.resubmittedMarkedPaper;
                break;
            default:
                return null;
        }

        const url = `${prefix}/api/file/assessment/${input.courseStudentAssessmentId}/${t}`;
        return {
            url,
            label: f?.path,
            remove: f?.remove
        };
    }
    else {
        
        return `${prefix}/api/file/${input.fileId}`;
    }
}